import { useContext } from "react";
import { useSelector } from "react-redux";
import { MoveOrganizationalUnitError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: MoveOrganizationalUnitError;
  moveOrganizationalUnit(
    request: Boundaries["moveOrganizationalUnit"]["request"],
  ): void;
}

function useMoveOrganizationalUnit(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isMoveOrganizationalUnitRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isMoveOrganizationalUnitRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isMoveOrganizationalUnitRequestFailure,
    ),
    error: useSelector(selector.getMoveOrganizationalUnitError),
    moveOrganizationalUnit: core.moveOrganizationalUnit,
  };
}

export { useMoveOrganizationalUnit };
